import { t as localeText } from "@/i18n/translate";
import { api } from "@/api/client";
import { getAsset } from "@/api/asset-actions";
import { unwrap } from "@/api/errors";
import type { V2Asset } from "../types";

/** Called only after the user explicitly confirms ownership or permission. */
export async function confirmImageUse(asset: V2Asset): Promise<V2Asset> {
  const latest = await getAsset(asset.id);
  if (latest.rights_status === "confirmed") return latest;
  if (latest.rights_status === "revoked") throw new Error(localeText("interface.this_image_s_usage_permission_is_unavailable_cho_38f0650d", { defaultValue: "This image’s usage permission is unavailable. Choose another image." }));
  return unwrap(await api.PATCH("/v1/assets/{id}", {
    params: { path: { id: latest.id } },
    body: { expected_version: latest.version, rights_attested: true, rights_basis: "owned_or_licensed" },
  }));
}
